import { HTTPClient, propsToDate } from "@abaco/web-common/src/HTTP";
import { InvoiceData, InvoiceDataOut, PaymentInfo, PaymentService, SubscriptionType } from "../models/Payment";

export default class PaymentApi {
    constructor(private http: HTTPClient, private rootPath: string) {}

    public async getInvoiceData(contractId: number): Promise<InvoiceData | null> {
        const url = `${this.rootPath}/v1/b2c/contract/${contractId}/last_invoice`;
        const res = await this.http.get(url);
        if (res.data !== null && res.data !== undefined && res.data !== "") {
            propsToDate(res.data, ["dt_insert"]);
        }
        return res.data;
    }

    public async saveInvoiceData(contractId: number, newInvoiceData: InvoiceDataOut): Promise<InvoiceData> {
        const url = `${this.rootPath}/v1/b2c/invoice/${contractId}/invoice`;
        const res = await this.http.post(url, newInvoiceData);
        return res.data;
    }

    public async editInvoiceData(pkid: number, editedContract: InvoiceDataOut): Promise<InvoiceData> {
        const url = `${this.rootPath}/v1/b2c/invoice/${pkid}`;
        const res = await this.http.put(url, editedContract);
        return res.data;
    }

    public async getPaymentInfo(service: PaymentService, subscriptionType: SubscriptionType): Promise<PaymentInfo> {
        const url = `${this.rootPath}/v1/payment/${service}/payment_info/${subscriptionType}`;
        const res = await this.http.get(url);
        if ("string" === typeof res.data.duration) {
            res.data.duration = parseInt(res.data.duration);
        }
        return res.data;
        // return {
        //     client_id: "AVenXqhSeDSaj0Op1l8oF86nDZtVZg0cUGnw6jQ1ngkSCvOl5i61I9YkqjW9iPvkZjyxZG9-h1l9132j",
        //     plan_id: "P-4CS998956F6846031MFK2JKQ",
        //     currency: "EUR",
        //     duration: 365,
        //     price: 220
        // }

        //   plan_id: 'P-26N90344FL252213SMFKXQRY'

        // P-0KJ07292F06400433MFKXACI actual 220€
        // "P-00Y928400H160573MME7XZSA" old 300€
        // live client id AZHNgsYagHkbQKeLZVDSKYITQjjnnsqZiQq-U5VgJqkY7XaQ7Z64dMhqccMUpz641IW8Z69YUZ-oR3B_
        // test client id AVenXqhSeDSaj0Op1l8oF86nDZtVZg0cUGnw6jQ1ngkSCvOl5i61I9YkqjW9iPvkZjyxZG9-h1l9132j
        //return {client_id: "AVenXqhSeDSaj0Op1l8oF86nDZtVZg0cUGnw6jQ1ngkSCvOl5i61I9YkqjW9iPvkZjyxZG9-h1l9132j"};
    }

    public async savePayment(pkid: number, paymentId: string, couponCode: string | null) {
        const form = couponCode ? { coupon_ids: couponCode } : {};
        const url = ` ${this.rootPath}/v1/b2c/${paymentId}/transaction/invoice/${pkid}`;
        const res = await this.http.put(url, form);
        return res.data;
    }
}
